import classnames from 'classnames';
import { Text } from '@doda/io-react/common';
import { LinkBox } from '@doda/common/src/logics/seoFooterLinkData/createSeoFooterLink';
import styles from '../../index.module.scss';

/**
 * ListItem Props
 */
interface Props {
  /** リンクリストのアイテム */
  linkItems: LinkBox['boxLinks'];
}

/**
 * ListItemはリンクのリストを表示するコンポーネント
 *
 * @param {Props} props - リンクリストのプロパティ
 * @returns {JSX.Element} - リンクリストの要素
 */
export const ListItem: React.FC<Props> = ({ linkItems }) => {
  return (
    <ul className={styles.seoFooterLink_linkList}>
      {linkItems?.map((linkItem, index) => (
        <li className={styles.seoFooterLink_listItem} key={index}>
          {linkItem.linkURL ? (
            <a
              href={linkItem.linkURL}
              className={styles.listItem__listItemInner}
              rel={linkItem.isNoFollow ? 'nofollow' : undefined}
            >
              <Text size="12" color="blue" as="span">
                {linkItem.linkText}
              </Text>
            </a>
          ) : (
            <Text
              size="12"
              as="span"
              className={classnames([styles['listItem--disabled']])}
            >
              {linkItem.linkText}
            </Text>
          )}
        </li>
      ))}
    </ul>
  );
};
